module.exports = __webpack_public_path__ + "static/media/main-contact.e9c9d6e3.svg";